module.exports = __webpack_public_path__ + "img/empty-comment.349dfc88.svg";